export default "/wp-content/themes/onnit/script/cart/dist/abiUpsellBg-8195b446.jpg";